(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('click', function(event) {
    var btn = event.target.closest('[data-qty-minus], [data-qty-plus]');
    if (!btn) return;
    var stepper = btn.closest('.pp-cart__stepper');
    var input = stepper.querySelector('.pp-cart__qty-input');
    var min = Number(input.min || 0);
    var current = Number(input.value || min);
    var next = btn.matches('[data-qty-plus]') ? current + 1 : Math.max(min, current - 1);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    var form = btn.closest('form');
    if (form) form.submit();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    var KEY = 'pp:filterGroups';
    function read() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
    function write(s) { try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {} }
    function init() {
      var groups = document.querySelectorAll('details.pp-filter-group[data-filter-key]');
      if (!groups.length) return;
      var state = read();
      groups.forEach(function (d) {
        var key = d.getAttribute('data-filter-key');
        if (Object.prototype.hasOwnProperty.call(state, key)) {
          d.open = !!state[key];
        }
        d.addEventListener('toggle', function () {
          var s = read();
          s[key] = d.open;
          write(s);
        });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  document.querySelectorAll('[data-sort-select]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sel.value);
      window.location.href = u.toString();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    function init() {
      var nav = document.querySelector('[data-mega-nav]');
      if (!nav) return;
      var overlay = document.querySelector('[data-mega-overlay]');
      var items = Array.prototype.slice.call(nav.querySelectorAll('[data-mega-item]'));

      function closeAll() {
        items.forEach(function (it) {
          it.classList.remove('is-open');
          var t = it.querySelector('[data-mega-toggle]');
          if (t) t.setAttribute('aria-expanded', 'false');
        });
        if (overlay) {
          overlay.classList.remove('is-active');
          overlay.setAttribute('hidden', '');
        }
      }

      function openItem(it) {
        closeAll();
        it.classList.add('is-open');
        var t = it.querySelector('[data-mega-toggle]');
        if (t) t.setAttribute('aria-expanded', 'true');
        if (overlay) {
          overlay.removeAttribute('hidden');
          requestAnimationFrame(function () { overlay.classList.add('is-active'); });
        }
      }

      items.forEach(function (it) {
        var toggle = it.querySelector('[data-mega-toggle]');
        if (!toggle) return;
        toggle.addEventListener('click', function (e) {
          e.preventDefault();
          if (it.classList.contains('is-open')) closeAll();
          else openItem(it);
        });
      });

      if (overlay) overlay.addEventListener('click', closeAll);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
      document.addEventListener('click', function (e) {
        if (!nav.contains(e.target)) closeAll();
      });
    }

    function initPredictiveSearch() {
      var wrap = document.querySelector('[data-predictive-search]');
      if (!wrap) return;
      var input = wrap.querySelector('[data-ps-input]');
      var results = wrap.querySelector('[data-ps-results]');
      var clearBtn = wrap.querySelector('[data-ps-clear]');
      var baseUrl = wrap.getAttribute('data-ps-url') || '/search/suggest';
      var timer = null;
      var controller = null;
      var items = [];
      var activeIndex = -1;
      var lastQuery = '';

      function openPanel() {
        if (!results.innerHTML.trim()) return;
        results.hidden = false;
        wrap.classList.add('is-open');
        input.setAttribute('aria-expanded', 'true');
      }

      function closePanel() {
        results.hidden = true;
        wrap.classList.remove('is-open');
        input.setAttribute('aria-expanded', 'false');
        setActive(-1);
      }

      function setActive(index) {
        activeIndex = index;
        items.forEach(function (el, i) {
          el.classList.toggle('is-active', i === index);
          el.setAttribute('aria-selected', i === index ? 'true' : 'false');
        });
        if (index >= 0 && items[index]) {
          input.setAttribute('aria-activedescendant', items[index].id);
          items[index].scrollIntoView({ block: 'nearest' });
        } else {
          input.removeAttribute('aria-activedescendant');
        }
      }

      function bindItems() {
        items = Array.prototype.slice.call(results.querySelectorAll('[data-ps-item]'));
        items.forEach(function (el, i) {
          el.id = 'PSOption-' + i;
          el.addEventListener('mouseenter', function () { setActive(i); });
        });
        setActive(-1);
      }

      function fetchResults(query) {
        if (controller) controller.abort();
        controller = new AbortController();
        var params = new URLSearchParams({
          q: query,
          'resources[type]': 'product,collection',
          'resources[limit]': '5',
          'resources[limit_scope]': 'each',
          section_id: 'predictive-search'
        });
        fetch(baseUrl + '?' + params.toString(), { signal: controller.signal })
          .then(function (response) { return response.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var panel = doc.querySelector('[data-ps-panel]');
            results.innerHTML = panel ? panel.outerHTML : '';
            lastQuery = query;
            bindItems();
            openPanel();
          })
          .catch(function (error) {
            if (error.name !== 'AbortError') closePanel();
          });
      }

      input.addEventListener('input', function () {
        var query = input.value.trim();
        clearBtn.hidden = query.length === 0;
        clearTimeout(timer);
        if (query.length < 2) {
          closePanel();
          results.innerHTML = '';
          lastQuery = '';
          return;
        }
        timer = setTimeout(function () { fetchResults(query); }, 220);
      });

      function reopenIfCached() {
        var query = input.value.trim();
        if (query.length >= 2 && query === lastQuery) openPanel();
      }
      input.addEventListener('focus', reopenIfCached);
      input.addEventListener('click', reopenIfCached);

      input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          if (!results.hidden) {
            e.preventDefault();
            closePanel();
          }
          return;
        }
        if (results.hidden || !items.length) return;
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          setActive((activeIndex + 1) % items.length);
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          setActive((activeIndex - 1 + items.length) % items.length);
        } else if (e.key === 'Enter' && activeIndex >= 0) {
          e.preventDefault();
          window.location.href = items[activeIndex].href;
        }
      });

      clearBtn.addEventListener('click', function () {
        input.value = '';
        clearBtn.hidden = true;
        results.innerHTML = '';
        lastQuery = '';
        closePanel();
        input.focus();
      });
      clearBtn.hidden = input.value.trim().length === 0;

      document.addEventListener('mousedown', function (e) {
        if (!wrap.contains(e.target)) closePanel();
      });
    }

    function initAll() {
      init();
      initPredictiveSearch();
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const thumb = event.target.closest('[data-product-thumb]');
    if (thumb) {
      const product = thumb.closest('.pp-product');
      const mediaId = thumb.dataset.productThumb;

      product.querySelectorAll('[data-product-thumb]').forEach((button) => {
        button.classList.toggle('is-active', button.dataset.productThumb === mediaId);
      });

      product.querySelectorAll('[data-product-media]').forEach((media) => {
        const active = media.dataset.productMedia === mediaId;
        media.classList.toggle('is-active', active);
        if (!active) {
          media.querySelectorAll('video').forEach((video) => video.pause());
          media.querySelectorAll('iframe').forEach((iframe) => {
            iframe.contentWindow?.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
            iframe.contentWindow?.postMessage('{"method":"pause"}', '*');
          });
        }
      });
    }

    const tab = event.target.closest('[data-product-tab]');
    if (tab) {
      const product = tab.closest('.pp-product');
      const tabKey = tab.dataset.productTab;

      product.querySelectorAll('[data-product-tab]').forEach((button) => {
        const active = button.dataset.productTab === tabKey;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      product.querySelectorAll('[data-product-panel]').forEach((panel) => {
        const active = panel.dataset.productPanel === tabKey;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    }

    const qtyButton = event.target.closest('[data-qty-minus], [data-qty-plus]');
    if (qtyButton) {
      const stepper = qtyButton.closest('.pp-pdp__qty-stepper');
      const input = stepper.querySelector('.pp-pdp__qty-input');
      const min = Number(input.min || 1);
      const current = Number(input.value || min);
      const next = qtyButton.matches('[data-qty-plus]') ? current + 1 : Math.max(min, current - 1);

      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  document.addEventListener('change', (event) => {
    const variantInput = event.target.closest('.pp-pdp__variant input[name="id"]');
    if (!variantInput) return;

    const product = variantInput.closest('.pp-product');
    product.querySelectorAll('.pp-pdp__variant').forEach((variant) => {
      variant.classList.toggle('is-active', variant.contains(variantInput));
    });

    const addText = product.querySelector('[data-add-label]');
    if (addText && variantInput.dataset.variantPrice) {
      addText.textContent = `${addText.dataset.addLabel} · ${variantInput.dataset.variantPrice}`;
    }
  });

  /* === Optie-gebaseerde variant-picker (snap naar geldige variant) === */
  (function () {
    function money(c) { return '\u20AC' + (c / 100).toFixed(2).replace('.', ','); }
    document.querySelectorAll('[data-pdp-options]').forEach(function (optsEl) {
      var root = optsEl.closest('.pp-product'); var form = optsEl.closest('form');
      if (!root || !form) return;
      var dataEl = root.querySelector('[data-pdp-variants]'); if (!dataEl) return;
      var variants; try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var idInput = form.querySelector('[data-variant-id]'), priceEl = root.querySelector('[data-pdp-price]'),
          saveEl = root.querySelector('[data-pdp-savebadge]'), stockEl = root.querySelector('[data-pdp-stock]'),
          stockText = root.querySelector('[data-stock-text]'), addBtn = form.querySelector('.pp-pdp__add'),
          addLabel = form.querySelector('[data-add-label]'), restockEl = root.querySelector('[data-pdp-restock]'),
          checkoutEl = form.querySelector('[data-dynamic-checkout]');
      var optionCount = optsEl.querySelectorAll('.pp-pdp__option').length;
      var restockEtas = {}; var restockDataEl = root.querySelector('[data-pdp-restock-etas]');
      if (restockDataEl) { try { restockEtas = JSON.parse(restockDataEl.textContent) || {}; } catch (e) { restockEtas = {}; } }
      function selected() { var s = []; optsEl.querySelectorAll('input[type="radio"]:checked').forEach(function (r) { s[parseInt(r.getAttribute('data-opt-pos'), 10) - 1] = r.value; }); return s; }
      function exact(sel) {
        if (sel.length !== optionCount) return null;
        for (var i = 0; i < optionCount; i++) { if (!sel[i]) return null; }
        return variants.find(function (v) { var vo = v.options || []; for (var k = 0; k < optionCount; k++) { if (vo[k] !== sel[k]) return false; } return true; }) || null;
      }
      function setRadios(opts) { (opts || []).forEach(function (ov, idx) { optsEl.querySelectorAll('input[data-opt-pos="' + (idx + 1) + '"]').forEach(function (r) { r.checked = (r.value === ov); }); }); }
      function showSharedGalleryOnly() {
        if (root.getAttribute('data-variant-gallery') !== 'true') return;
        var firstSharedThumb = null;
        root.querySelectorAll('[data-product-thumb]').forEach(function (thumb) {
          var isShared = thumb.getAttribute('data-shared-media') === 'true';
          thumb.hidden = !isShared;
          if (isShared && !firstSharedThumb) firstSharedThumb = thumb;
        });
        if (firstSharedThumb) firstSharedThumb.click();
      }
      function render(v) {
        optsEl.querySelectorAll('.pp-pdp__opt').forEach(function (l) { var inp = l.querySelector('input'); l.classList.toggle('is-active', inp && inp.checked); });
        optsEl.querySelectorAll('[data-option-current]').forEach(function (s) { var r = optsEl.querySelector('input[data-opt-pos="' + s.getAttribute('data-option-current') + '"]:checked'); if (r) s.textContent = r.value; });
        if (!v) {
          if (idInput) { idInput.value = ''; idInput.disabled = true; }
          if (addBtn) addBtn.disabled = true;
          if (addLabel) addLabel.textContent = addLabel.getAttribute('data-choose-label') || '';
          if (restockEl) restockEl.hidden = true;
          if (checkoutEl) checkoutEl.hidden = true;
          showSharedGalleryOnly();
          return;
        }
        if (idInput) { idInput.value = v.id; idInput.disabled = false; }
        var sale = v.compare_at_price && v.compare_at_price > v.price;
        if (priceEl) priceEl.innerHTML = '<span class="pp-price pp-price--lg' + (sale ? ' pp-price--sale' : '') + '"><span class="pp-price__current">' + money(v.price) + '</span>' + (sale ? '<s class="pp-price__compare">' + money(v.compare_at_price) + '</s>' : '') + '</span>';
        if (saveEl) { if (sale) { var pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price); saveEl.innerHTML = '<span class="pp-badge pp-badge--sale pp-badge--md">Bespaar ' + pct + '%</span>'; } else saveEl.innerHTML = ''; }
        if (stockEl) { stockEl.classList.toggle('pp-pdp__stock--out', !v.available); if (stockText) stockText.textContent = v.available ? (stockEl.getAttribute('data-in-label') || '') : (stockEl.getAttribute('data-out-label') || ''); }
        if (restockEl) {
          var eta = restockEtas[String(v.id)];
          if (!v.available && eta) { restockEl.textContent = (restockEl.getAttribute('data-restock-template') || '').replace('[date]', eta); restockEl.hidden = false; }
          else { restockEl.hidden = true; }
        }
        if (addBtn) addBtn.disabled = !v.available;
        if (addLabel) addLabel.textContent = v.available ? (addLabel.getAttribute('data-add-label') + ' \u00B7 ' + money(v.price)) : (addLabel.getAttribute('data-soldout-label') || 'Uitverkocht');
        if (checkoutEl) checkoutEl.hidden = !v.available;
        if (root.getAttribute('data-variant-gallery') === 'true') {
          var activeVariantId = String(v.id), activeVariantThumb = null;
          root.querySelectorAll('[data-product-thumb]').forEach(function (thumb) {
            var variantIds = (thumb.getAttribute('data-variant-ids') || '').split(',').filter(Boolean);
            var isShared = thumb.getAttribute('data-shared-media') === 'true';
            var matchesVariant = variantIds.indexOf(activeVariantId) !== -1;
            thumb.hidden = !isShared && !matchesVariant;
            if (matchesVariant) activeVariantThumb = thumb;
          });
          if (activeVariantThumb) activeVariantThumb.click();
        } else if (v.featured_media && v.featured_media.id) {
          var thumb = root.querySelector('[data-product-thumb="' + v.featured_media.id + '"]');
          if (thumb) thumb.click();
        }
      }
      optsEl.addEventListener('change', function (e) {
        var v = exact(selected());
        if (!v && e.target && e.target.matches && e.target.matches('input[type="radio"]')) {
          var pos = parseInt(e.target.getAttribute('data-opt-pos'), 10), val = e.target.value;
          v = variants.find(function (x) { return x.available && (x.options || [])[pos - 1] === val; }) || variants.find(function (x) { return (x.options || [])[pos - 1] === val; });
          if (v) setRadios(v.options);
        }
        render(v);
      });
      render(exact(selected()));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
